function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import find from 'lodash/find';
import { registerAction, unregisterAction } from 'helpers/reducerTools';
import { SIGN_OUT_SUCCESS } from 'modules/Account/actionTypes';
import * as actionTypes from './actionTypes';
import * as constants from './constants';
const initialState = {
    countries: [],
    allCountries: [],
    languages: [],
    fetching: [],
    sending: [],
    errors: [],
    enableCountryErrors: null,
    isDeleteCountryResultSuccess: null,
    configuredCountry: null,
    countryConfiguration: null,
    identifierOptionFormValueInitialValue: null,
    updateOrAddIdentifierTerm: null
};
export default function reducer(state = _object_spread({}, initialState), action = {}) {
    switch(action.type){
        case actionTypes.FETCH_COUNTRIES:
            {
                return _object_spread_props(_object_spread({}, state), {
                    fetching: registerAction(state.fetching, actionTypes.FETCH_COUNTRIES),
                    errors: unregisterAction(state.errors, actionTypes.FETCH_COUNTRIES)
                });
            }
        case actionTypes.FETCH_COUNTRIES_SUCCESS:
            {
                const { countries } = action.payload;
                return _object_spread_props(_object_spread({}, state), {
                    countries,
                    fetching: unregisterAction(state.fetching, actionTypes.FETCH_COUNTRIES)
                });
            }
        case actionTypes.FETCH_COUNTRIES_ERROR:
            {
                return _object_spread_props(_object_spread({}, state), {
                    fetching: unregisterAction(state.fetching, actionTypes.FETCH_COUNTRIES),
                    errors: registerAction(state.errors, actionTypes.FETCH_COUNTRIES)
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.FETCH_ALL_COUNTRIES:
            {
                return _object_spread_props(_object_spread({}, state), {
                    fetching: registerAction(state.fetching, actionTypes.FETCH_ALL_COUNTRIES),
                    errors: unregisterAction(state.errors, actionTypes.FETCH_ALL_COUNTRIES)
                });
            }
        case actionTypes.FETCH_ALL_COUNTRIES_SUCCESS:
            {
                const { countries } = action.payload;
                return _object_spread_props(_object_spread({}, state), {
                    allCountries: countries,
                    fetching: unregisterAction(state.fetching, actionTypes.FETCH_ALL_COUNTRIES)
                });
            }
        case actionTypes.FETCH_ALL_COUNTRIES_ERROR:
            {
                return _object_spread_props(_object_spread({}, state), {
                    fetching: unregisterAction(state.fetching, actionTypes.FETCH_ALL_COUNTRIES),
                    errors: registerAction(state.errors, actionTypes.FETCH_ALL_COUNTRIES)
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.FETCH_LANGUAGES:
            {
                return _object_spread_props(_object_spread({}, state), {
                    fetching: registerAction(state.fetching, actionTypes.FETCH_LANGUAGES),
                    errors: unregisterAction(state.errors, actionTypes.FETCH_LANGUAGES)
                });
            }
        case actionTypes.FETCH_LANGUAGES_SUCCESS:
            {
                const { languages } = action.payload;
                return _object_spread_props(_object_spread({}, state), {
                    languages,
                    fetching: unregisterAction(state.fetching, actionTypes.FETCH_LANGUAGES)
                });
            }
        case actionTypes.FETCH_LANGUAGES_ERROR:
            {
                return _object_spread_props(_object_spread({}, state), {
                    fetching: unregisterAction(state.fetching, actionTypes.FETCH_LANGUAGES),
                    errors: registerAction(state.errors, actionTypes.FETCH_LANGUAGES)
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.ADD_COUNTRY:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: registerAction(state.sending, actionTypes.ADD_COUNTRY),
                    errors: unregisterAction(state.errors, actionTypes.ADD_COUNTRY)
                });
            }
        case actionTypes.ADD_COUNTRY_SUCCESS:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: unregisterAction(state.sending, actionTypes.ADD_COUNTRY)
                });
            }
        case actionTypes.ADD_COUNTRY_ERROR:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: unregisterAction(state.sending, actionTypes.ADD_COUNTRY),
                    errors: registerAction(state.errors, actionTypes.ADD_COUNTRY)
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.ENABLE_COUNTRY:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: registerAction(state.sending, actionTypes.ENABLE_COUNTRY),
                    errors: unregisterAction(state.errors, actionTypes.ENABLE_COUNTRY)
                });
            }
        case actionTypes.ENABLE_COUNTRY_SUCCESS:
            {
                return _object_spread_props(_object_spread({}, state), {
                    enableCountryErrors: null,
                    sending: unregisterAction(state.sending, actionTypes.ENABLE_COUNTRY)
                });
            }
        case actionTypes.ENABLE_COUNTRY_ERROR:
            {
                let enableCountryErrors;
                if (action.payload && action.payload.errors) {
                    const { errors } = action.payload;
                    enableCountryErrors = [];
                    const errorsKeys = Object.keys(errors);
                    Object.entries(constants.ENABLE_COUNTRY_ERRORS).forEach(([key, value])=>{
                        if (errors[value] || find(errorsKeys, (x)=>x.startsWith(value))) {
                            enableCountryErrors.push(key);
                        }
                    });
                }
                return _object_spread_props(_object_spread({}, state), {
                    enableCountryErrors,
                    sending: unregisterAction(state.sending, actionTypes.ENABLE_COUNTRY),
                    errors: registerAction(state.errors, actionTypes.ENABLE_COUNTRY)
                });
            }
        case actionTypes.ENABLE_COUNTRY_CLEAR:
            {
                return _object_spread_props(_object_spread({}, state), {
                    enableCountryErrors: null
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.DELETE_COUNTRY:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: registerAction(state.sending, actionTypes.DELETE_COUNTRY),
                    errors: unregisterAction(state.errors, actionTypes.DELETE_COUNTRY)
                });
            }
        case actionTypes.DELETE_COUNTRY_SUCCESS:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: unregisterAction(state.sending, actionTypes.DELETE_COUNTRY)
                });
            }
        case actionTypes.DELETE_COUNTRY_ERROR:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: unregisterAction(state.sending, actionTypes.DELETE_COUNTRY),
                    errors: registerAction(state.errors, actionTypes.DELETE_COUNTRY)
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.FETCH_COUNTRY:
            {
                return _object_spread_props(_object_spread({}, state), {
                    fetching: registerAction(state.fetching, actionTypes.FETCH_COUNTRY),
                    errors: unregisterAction(state.errors, actionTypes.FETCH_COUNTRY)
                });
            }
        case actionTypes.FETCH_COUNTRY_SUCCESS:
            {
                const { configuredCountry } = action.payload;
                return _object_spread_props(_object_spread({}, state), {
                    configuredCountry,
                    fetching: unregisterAction(state.fetching, actionTypes.FETCH_COUNTRY)
                });
            }
        case actionTypes.FETCH_COUNTRY_ERROR:
            {
                return _object_spread_props(_object_spread({}, state), {
                    fetching: unregisterAction(state.fetching, actionTypes.FETCH_COUNTRY),
                    errors: registerAction(state.errors, actionTypes.FETCH_COUNTRY)
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.FETCH_COUNTRY_CONFIGURATION:
            {
                return _object_spread_props(_object_spread({}, state), {
                    fetching: registerAction(state.fetching, actionTypes.FETCH_COUNTRY_CONFIGURATION),
                    errors: unregisterAction(state.errors, actionTypes.FETCH_COUNTRY_CONFIGURATION)
                });
            }
        case actionTypes.FETCH_COUNTRY_CONFIGURATION_SUCCESS:
            {
                const { countryConfiguration } = action.payload;
                return _object_spread_props(_object_spread({}, state), {
                    countryConfiguration,
                    fetching: unregisterAction(state.fetching, actionTypes.FETCH_COUNTRY_CONFIGURATION)
                });
            }
        case actionTypes.FETCH_COUNTRY_CONFIGURATION_ERROR:
            {
                return _object_spread_props(_object_spread({}, state), {
                    fetching: unregisterAction(state.fetching, actionTypes.FETCH_COUNTRY_CONFIGURATION),
                    errors: registerAction(state.errors, actionTypes.FETCH_COUNTRY_CONFIGURATION)
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.SET_IDENTIFIER_OPTION_FORM_VALUE:
            {
                const { initialFormValue } = action.payload;
                return _object_spread_props(_object_spread({}, state), {
                    identifierOptionFormValueInitialValue: initialFormValue
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.SET_UPDATE_OR_ADD_IDENTIFIER_TERM:
            {
                const { term } = action.payload;
                return _object_spread_props(_object_spread({}, state), {
                    updateOrAddIdentifierTerm: term
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.UPDATE_COUNTRY_CONFIGURATION_GENERAL:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: registerAction(state.sending, actionTypes.UPDATE_COUNTRY_CONFIGURATION_GENERAL),
                    errors: unregisterAction(state.errors, actionTypes.UPDATE_COUNTRY_CONFIGURATION_GENERAL)
                });
            }
        case actionTypes.UPDATE_COUNTRY_CONFIGURATION_GENERAL_SUCCESS:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: unregisterAction(state.sending, actionTypes.UPDATE_COUNTRY_CONFIGURATION_GENERAL)
                });
            }
        case actionTypes.UPDATE_COUNTRY_CONFIGURATION_GENERAL_ERROR:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: unregisterAction(state.sending, actionTypes.UPDATE_COUNTRY_CONFIGURATION_GENERAL),
                    errors: registerAction(state.errors, actionTypes.UPDATE_COUNTRY_CONFIGURATION_GENERAL)
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.UPDATE_COUNTRY_CONFIGURATION_UNIT_OF_MEASUREMENTS:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: registerAction(state.sending, actionTypes.UPDATE_COUNTRY_CONFIGURATION_UNIT_OF_MEASUREMENTS),
                    errors: unregisterAction(state.errors, actionTypes.UPDATE_COUNTRY_CONFIGURATION_UNIT_OF_MEASUREMENTS)
                });
            }
        case actionTypes.UPDATE_COUNTRY_CONFIGURATION_UNIT_OF_MEASUREMENTS_SUCCESS:
            {
                const { unitMeasurements } = action.payload;
                return _object_spread_props(_object_spread({}, state), {
                    unitMeasurements,
                    sending: unregisterAction(state.sending, actionTypes.UPDATE_COUNTRY_CONFIGURATION_UNIT_OF_MEASUREMENTS)
                });
            }
        case actionTypes.UPDATE_COUNTRY_CONFIGURATION_UNIT_OF_MEASUREMENTS_ERROR:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: unregisterAction(state.sending, actionTypes.UPDATE_COUNTRY_CONFIGURATION_UNIT_OF_MEASUREMENTS),
                    errors: registerAction(state.errors, actionTypes.UPDATE_COUNTRY_CONFIGURATION_UNIT_OF_MEASUREMENTS)
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.UPDATE_COUNTRY_CONFIGURATION_GLUCOSE_RANGES:
            {
                const { glucoseRanges } = action.payload;
                return _object_spread_props(_object_spread({}, state), {
                    glucoseRanges,
                    sending: registerAction(state.sending, actionTypes.UPDATE_COUNTRY_CONFIGURATION_GLUCOSE_RANGES),
                    errors: unregisterAction(state.errors, actionTypes.UPDATE_COUNTRY_CONFIGURATION_GLUCOSE_RANGES)
                });
            }
        case actionTypes.UPDATE_COUNTRY_CONFIGURATION_GLUCOSE_RANGES_SUCCESS:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: unregisterAction(state.sending, actionTypes.UPDATE_COUNTRY_CONFIGURATION_GLUCOSE_RANGES)
                });
            }
        case actionTypes.UPDATE_COUNTRY_CONFIGURATION_GLUCOSE_RANGES_ERROR:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: unregisterAction(state.sending, actionTypes.UPDATE_COUNTRY_CONFIGURATION_GLUCOSE_RANGES),
                    errors: registerAction(state.errors, actionTypes.UPDATE_COUNTRY_CONFIGURATION_GLUCOSE_RANGES)
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.UPDATE_COUNTRY_CONFIGURATION_PAYERS:
            {
                const { payers } = action.payload;
                return _object_spread_props(_object_spread({}, state), {
                    payers,
                    sending: registerAction(state.fetching, actionTypes.UPDATE_COUNTRY_CONFIGURATION_PAYERS),
                    errors: unregisterAction(state.errors, actionTypes.UPDATE_COUNTRY_CONFIGURATION_PAYERS)
                });
            }
        case actionTypes.UPDATE_COUNTRY_CONFIGURATION_PAYERS_SUCCESS:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: unregisterAction(state.fetching, actionTypes.UPDATE_COUNTRY_CONFIGURATION_PAYERS)
                });
            }
        case actionTypes.UPDATE_COUNTRY_CONFIGURATION_PAYERS_ERROR:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: unregisterAction(state.fetching, actionTypes.UPDATE_COUNTRY_CONFIGURATION_PAYERS),
                    errors: registerAction(state.errors, actionTypes.UPDATE_COUNTRY_CONFIGURATION_PAYERS)
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.UPDATE_COUNTRY_CONFIGURATION_IDENTIFIERS:
            {
                const { identifiers } = action.payload;
                return _object_spread_props(_object_spread({}, state), {
                    identifiers,
                    sending: registerAction(state.sending, actionTypes.UPDATE_COUNTRY_CONFIGURATION_IDENTIFIERS),
                    errors: unregisterAction(state.errors, actionTypes.UPDATE_COUNTRY_CONFIGURATION_IDENTIFIERS)
                });
            }
        case actionTypes.UPDATE_COUNTRY_CONFIGURATION_IDENTIFIERS_SUCCESS:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: unregisterAction(state.sending, actionTypes.UPDATE_COUNTRY_CONFIGURATION_IDENTIFIERS)
                });
            }
        case actionTypes.UPDATE_COUNTRY_CONFIGURATION_IDENTIFIERS_ERROR:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: unregisterAction(state.sending, actionTypes.UPDATE_COUNTRY_CONFIGURATION_IDENTIFIERS),
                    errors: registerAction(state.errors, actionTypes.UPDATE_COUNTRY_CONFIGURATION_IDENTIFIERS)
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.UPDATE_COUNTRY_CONFIGURATION_METERS:
            {
                const { devices } = action.payload;
                return _object_spread_props(_object_spread({}, state), {
                    devices,
                    sending: registerAction(state.sending, actionTypes.UPDATE_COUNTRY_CONFIGURATION_METERS),
                    errors: unregisterAction(state.errors, actionTypes.UPDATE_COUNTRY_CONFIGURATION_METERS)
                });
            }
        case actionTypes.UPDATE_COUNTRY_CONFIGURATION_METERS_SUCCESS:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: unregisterAction(state.sending, actionTypes.UPDATE_COUNTRY_CONFIGURATION_METERS)
                });
            }
        case actionTypes.UPDATE_COUNTRY_CONFIGURATION_METERS_ERROR:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: unregisterAction(state.sending, actionTypes.UPDATE_COUNTRY_CONFIGURATION_METERS),
                    errors: registerAction(state.errors, actionTypes.UPDATE_COUNTRY_CONFIGURATION_METERS)
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case SIGN_OUT_SUCCESS:
            {
                return _object_spread({}, initialState);
            }
        //------------------------------------------------------------------------------------------------------------------
        default:
            {
                return state;
            }
    }
}
